<template>
     <v-select
        :items="getYears"
        :label="getLabel"
        item-value="text"
        v-model="selected_year"
        @change="setYear()"
        ></v-select>
</template>
<script>
export default {
    props:['label'],
    data(){
        return{
            selected_year: ''
        }
    },
    methods:{
        setYear(){
            this.$emit('setYear', this.selected_year)
        }
    },
    computed:{
        getYears(){
          let year = new Date().getFullYear()
           return Array.from({length: year - 1900}, (value, index) => 2010 + index)
        },

        getLabel(){
            return this.label
        }
    },
    mounted(){
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/global/year_picker.vue